<template>
	<div id="container">
		<div class="banner">
			<Logout v-if="haslogin" style="float: right"></Logout>
			<Login v-else="" style="float: right"></Login>
		</div>
		<div class="game_title">精<span class="border_blue">彩游</span>戏</div>
		<div class="games">
			<div >
				<img class="games_img" src="../../images/game1.png" alt="" @click="changePage('chuanqi')">
				<div class="games_inner">
					<p class="games_title">传奇来了</p>
					<span>传奇来了是一款传承十多年核心的战斗ARPG手游巨作，在这里你可以提升战斗力和千万英雄豪杰一起战个痛快，万人皇城巅峰对决，享受到专属于你的热血荣耀吧!</span>
				</div>
			</div>
			<div >
				<img class="games_img" src="../../images/game2.png" alt="" @click="changePage('rexue')">
				<div class="games_inner">
					<p class="games_title">热血合击</p>
					<span>热血合击是一款很有特色的皇城争霸传奇战斗类RPG手游，千人同屏热血厮杀，超炫酷究极技能华丽释放，时刻让你爽到爆，再现了1.76版本的激情玩法，万人争霸皇城给你无限激情竞技pk，无限爆装，自由灵活，争霸天！</span>
				</div>
			</div>
			<div >
				<img class="games_img" src="../../images/game3.png" alt="" @click="changePage('xiyou')">
				<div class="games_inner">
					<p class="games_title">西游七十二变</p>
					<span>《西游七十二变》是一款基于H5技术打造的暗黑西游风MMORPG网游，游戏突破了传统H5的现状，其画面精美、动作流畅、打击感十足，更可以在PC、手机、平板电脑等多个终端设备上流畅运行，可能是目前H5领域整体品质最高的一款游戏。</span>
				</div>
			</div>
		</div>
		<div style="text-align: center;padding: 30px 0;background-color: #EFEFEF;margin-top: 38px">
			<img src="../../images/dt.png" alt="" style="width: 97px">
		</div>
	</div>
</template>

<script>
	import Login from '../../components/login/login.vue'
  import Logout from '../../components/login/logout.vue'
  import Reg from '../../components/reg/reg.vue'
  import { mapState ,mapMutations} from 'vuex'


  export default {
		data() {
			return {
			}
		},
    components:{
      Login,
      Logout,
      Reg
    },
    computed: mapState([
      'loginPage','haslogin','userData'
    ]),
    methods:{
      ...mapMutations([
        'setGameName'
      ]),
		  changePage(game){
		    if(!this.userData.gid){
          this.$alert("请先登录", '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({path: '/home'});
            }
          });
          return false
				}
				this.setGameName(game);
        window.sessionStorage.setItem("gameName",game);
		    this.$ajaxUrls.appKey = this.$ajaxUrls.gamesKey[game];
		    window.sessionStorage.setItem("appKey",this.$ajaxUrls.gamesKey[game]);
        this.$router.push({path: '/toGame?clientType=3'});
      }
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../components/style/mixin';
	#container{margin-top: -5px}
	.border_blue{border-bottom: 3px solid #1990FF;padding-bottom: 5px}
	.banner{background: url("../../images/middle_bg.png") no-repeat top 0 left 0 /100% 100%;height: 512px;padding-top: 75px;padding-right: 11%}
	@media screen and  (max-width: 1400px){
		.banner{height: 400px;padding-top:15px;padding-right: 5%}
	}
	.game_title{color: #333333;text-align: center;font-size: 42px;margin-top: 30px;margin-bottom: 30px;line-height: 50px;height: 50px;}
	.games{display: flex;justify-content: center;text-align: center}
	.games>div{width: 460px}
	.games_title{color: #333333;font-size: 24px;margin-bottom: 8px;margin-top: 5px}
	.games_inner{width: 360px;margin: 0 auto;color: #666666;text-align: left;}
	.games_img{width: 355px;height: 237px;cursor: pointer}
	.reg_page{background-color: rgb(254,254,254)}
</style>
